import edit from './edit';
import save from './save';
import accTopCntBlockMeta from './block.json';
import { accordionIcon as icon } from './icons';
import './style.scss';

const { registerBlockType } = wp.blocks;

const { name, ...settings } = accTopCntBlockMeta;

registerBlockType(name, {
  ...settings,
  icon,
  edit,
  save,
});
